import React, { useRef, useState, useEffect } from 'react'
import { connectGeoSearch } from 'react-instantsearch-dom'

import RedoSearchButton from '../../atoms/Map/RedoSearchButton'

import Map from './index'

const GeoSearch = ({
  hits,
  position,
  currentRefinement,
  isRefinedWithMap,
  refine,
  creatURL,
  ...props
}) => {
  const ref = useRef()
  const [active, setActive] = useState()
  const [ready, setReady] = useState()

  const redoSearch = () => {
    setActive(false)
    const { _ne, _sw } = ref.current.getMap().getBounds()
    refine({
      northEast: {
        lat: _ne.lat,
        lng: _ne.lng,
      },
      southWest: {
        lat: _sw.lat,
        lng: _sw.lng,
      },
    })
  }

  const observer = {
    onInteractionStateChange: state => {
      if (ready && state.isDragging) setActive(true)
    },
    onTransitionEnd: () => {
      if (!ready) setReady(true)
      else setActive(true)
    },
  }

  const hash = hits.map(a => a.id).join('-')
  useEffect(() => {
    setActive(false)
    setReady(false)
  }, [hash])

  return (
    <Map ref={ref} apartments={hits} {...props} {...observer}>
      <RedoSearchButton onClick={redoSearch} disabled={!active} type='secondary'>
        Redo search
      </RedoSearchButton>
    </Map>
  )
}

export default connectGeoSearch(GeoSearch)
